import React from 'react';
import { useTheme } from 'styled-components';
export const useInfoIcons = (icons) => {
    const { sizeUnit } = useTheme();
    icons = icons !== null && icons !== void 0 ? icons : emptyObject;
    return (hooks) => {
        hooks.visibleColumnsDeps.push((deps, { instance }) => {
            const hasIcon = Object.entries(icons !== null && icons !== void 0 ? icons : {}).some(([iconKey, { checkHasIcon, icon }]) => {
                var _a;
                return checkHasIcon
                    ? Boolean(icon) &&
                        ((_a = instance.data) === null || _a === void 0 ? void 0 : _a.some((row) => checkHasIcon({ row })))
                    : false;
            });
            if (hasIcon) {
                return [...deps, instance.data];
            }
            return deps;
        });
        hooks.visibleColumns.push((columns, { instance }) => {
            // todo: the page should be considered here, not all the data. But instance.page doesnot exist here
            const entries = Object.entries(icons !== null && icons !== void 0 ? icons : {}).reverse();
            return entries.reduce((acc, [iconKey, { icon: Icon, checkHasIcon, options }]) => {
                var _a, _b;
                if (checkHasIcon &&
                    Boolean(Icon) &&
                    ((_a = instance.data) === null || _a === void 0 ? void 0 : _a.some((row) => checkHasIcon({ row })))) {
                    const style = {
                        width: sizeUnit * ((_b = options === null || options === void 0 ? void 0 : options.size) !== null && _b !== void 0 ? _b : 11),
                        paddingTop: 0,
                        paddingBottom: 0
                    };
                    acc = [
                        {
                            id: iconKey,
                            // @ts-ignore
                            accessor: iconKey,
                            style,
                            isVirtualColumn: true,
                            disableFilters: true,
                            disableResizing: true,
                            disableSortBy: true,
                            disableGroupBy: true,
                            className: `invent-table-info-icon invent-table--info-icon-${iconKey}`,
                            Header: () => null,
                            Cell: ({ cell }) => {
                                const row = cell.row;
                                return React.createElement(Icon, { row: row.original });
                            }
                        },
                        ...acc
                    ];
                }
                return acc;
            }, columns);
        });
    };
};
const emptyObject = {};
